import React from "react"
import { View } from "react-native";
import { MaterialIcons } from '@expo/vector-icons';
import useMediumscreen from 'hooks/useMediumScreen';
import CloverConnectionStatusButton from "./CloverConnectionStatusButton";
import CloverConnectionStatusButtonProps from "types/components/CloverConnectionStatusButtonProps";
import CloverConnectionStatusesProps from "types/components/CloverConnectionStatusesProps";
import { CloverPointConnectionStatusType } from "types/enums/CloverPointConnectionStatusType";
import BottomSheet from "components/BottomSheet";
import BottomSheetButton from "components/BottomSheetButton";
import { useTranslation } from "react-i18next";

import { colors } from "../../config";

export default ({ cloverPointStatuses, navigation, isForVenue, commerceCode, venueCode, isForReports }: CloverConnectionStatusesProps): JSX.Element => {
    
    const [isModalVisible, setIsModalVisible] = React.useState(false);

    const mediumScreen = useMediumscreen();

    const { t } = useTranslation();

    const cloverConnectionButtons: CloverConnectionStatusButtonProps[] = React.useMemo(() => {
        return [
            {
                text: cloverPointStatuses.online.toString(), 
                description: t('clover-connection-status.connected'),
                iconName: 'wifi', 
                backgroundColor: colors.cloverConnected, 
                borderColor: '', 
                fillColor: '#fff',
                onPress: () => {
                    if (isForReports) return
                    navigation.navigate('CloverConnectionReportsScreen', { commerceCode, ...(isForVenue && {venueCode}), connectionStatus: CloverPointConnectionStatusType.CONNECTED });
                    setIsModalVisible(false);
                }
            },
            {
                text: cloverPointStatuses.unstable.toString(), 
                description: t('clover-connection-status.unstable'),
                iconName: 'perm-scan-wifi', 
                backgroundColor: colors.cloverUnstable, 
                borderColor: '', 
                fillColor: '#fff',
                onPress: () => {
                    if (isForReports) return
                    navigation.navigate('CloverConnectionReportsScreen', { commerceCode, ...(isForVenue && {venueCode}), connectionStatus: CloverPointConnectionStatusType.UNSTABLE });
                    setIsModalVisible(false);
                }
            },
            {
                text: cloverPointStatuses.offline.toString(),
                description: t('clover-connection-status.disconnected'),
                iconName: 'wifi-off', 
                backgroundColor: colors.cloverDisconnected, 
                borderColor: '', 
                fillColor: '#fff',
                onPress: () => {
                    if (isForReports) return
                    navigation.navigate('CloverConnectionReportsScreen', { commerceCode, ...(isForVenue && {venueCode}), connectionStatus: CloverPointConnectionStatusType.DISCONNECTED });
                    setIsModalVisible(false);
                }
            },
            {
                text: cloverPointStatuses.whitoutPaper.toString(), 
                description: t('clover-connection-status.without-paper'),
                iconName: 'print-disabled', 
                backgroundColor: colors.gray, 
                borderColor: colors.gray, 
                fillColor: colors.white,
                onPress: () => {
                    if (isForReports) return
                    navigation.navigate('CloverConnectionReportsScreen', { commerceCode, ...(isForVenue && {venueCode}) });
                    setIsModalVisible(false);
                }
            },

            {
                text: cloverPointStatuses.isInactive.toString(), 
                description: t('clover-connection-status.inactive'),
                iconName: 'block', 
                backgroundColor: colors.darkGray, 
                borderColor: colors.darkGray, 
                fillColor: colors.white,
                onPress: () => {
                    if (isForReports) return
                    navigation.navigate('CloverConnectionReportsScreen', { commerceCode, ...(isForVenue && {venueCode}), connectionStatus: "Inactive"});
                    setIsModalVisible(false);
                }
            },
        ]
    }, [cloverPointStatuses]);

    const renderCloverPointStatuses = (): JSX.Element => {
        return (
            <View style={{
                    flexDirection: mediumScreen || isForVenue ? 'row' : 'column', 
                    justifyContent: 'space-between',
                    marginRight: isForVenue ? 0 : mediumScreen ? 30 : 0,
                }}
            >
                {cloverConnectionButtons.map((cloverConnectionButton, index) => {
                    return (
                        <CloverConnectionStatusButton
                            key={index}
                            borderColor={cloverConnectionButton.borderColor}
                            backgroundColor={cloverConnectionButton.backgroundColor}
                            fillColor={cloverConnectionButton.fillColor}
                            iconName={cloverConnectionButton.iconName}
                            text={cloverConnectionButton.text}
                            onPress={cloverConnectionButton.onPress}
                            isForVenue={isForVenue}
                            isFirstButton={index === 0}
                            isLastButton={index === cloverConnectionButtons.length - 1}
                        />
                    )
                })}

            </View>
        )
    }

    const renderCloverPointStatusesBottomSheet = (): JSX.Element => {
        return (
            <View>
                {cloverConnectionButtons.map((cloverConnectionButton, index) => {
                    return (
                        <BottomSheetButton
                            key={index}
                            fillColor={cloverConnectionButton.backgroundColor}
                            iconName={cloverConnectionButton.iconName}
                            description={cloverConnectionButton.description ?? ''}
                            count={cloverConnectionButton.text}
                            onPress={cloverConnectionButton.onPress}
                        />
                    )
                })}
            </View>
        )
    }

    return (
        <View>
            {mediumScreen || isForVenue ? renderCloverPointStatuses()  
            :<MaterialIcons                
                name="wifi"
                type="ionicon"
                color={'#fff'}
                size={35}
                onPress={() => {
                    setIsModalVisible(true);
                }}
            />
            }

            <BottomSheet
                isBottomSheetVisible={isModalVisible}
                setIsBottomSheetVisible={setIsModalVisible}
                children={renderCloverPointStatusesBottomSheet()}
                title={t('clover-connection-status.connection-statuses')}
            />
           
        </View>
    )
}